
















































































































































import { Component, Prop } from 'vue-property-decorator';
import { IGoal, IGoalResult } from 'admiral-core';
import { mixins } from 'vue-class-component';
import { BaseMixin } from '@/mixins/BaseMixin';
import Avatar from '@/components/common/Avatar.vue';
import VueApexCharts from 'vue-apexcharts';
import AgencyGoalProgress from '@/views/pages/fivgoals/components/AgencyGoalProgress.vue';
import { PermissionMixin } from '@/mixins/PermissionMixin';
import AgencyAvatar from '@/components/common/AgencyAvatar.vue';
import { ListIcon } from 'vue-feather-icons';
import { Util } from '@/utils/Util';
import dayjs from 'dayjs';
import { GoalApi } from '@/services/GoalApi';

@Component({
  components: { AgencyAvatar, AgencyGoalProgress, Avatar, apexchart: VueApexCharts, ListIcon },
})
export default class TeamGoalRow extends mixins(BaseMixin, PermissionMixin) {
  @Prop({ required: false, type: Object, default: () => null })
  goal!: IGoal;

  @Prop({ required: true, type: String, default: () => 'policed' })
  type!: 'policed' | 'custom';

  result: IGoalResult | null = null;
  goalValueHover = false;
  goalCurrentValueHover = false;

  async mounted() {
    await this.loadGoalResult();
  }

  async loadGoalResult() {
    try {
      const response = await GoalApi.getGoalResult(this.goal.id, new Date().getFullYear());
      this.result = response.data;
    } catch (e) {
      console.log(e);
    }
  }

  handleOpenEditGoal(goal: IGoal) {
    this.$emit('open-edit-goal', goal);
  }

  handleOpenPolicies(status?: string[], isRelativeValue?: boolean) {
    const args: any = {
      columns: ['updatedAt', 'tasks', 'customer', 'product', 'value', 'quantity', 'probability'],
    };
    if (status) {
      args.status = status;
    }
    if (isRelativeValue) {
      args.isRelativeValue = isRelativeValue;
      args.columns.push('relativeValue');
    }

    if (this.goal.user) {
      args.users = [this.goal.user];
    } else {
      args.agency = this.agency;
    }

    this.$emit('open', args);
  }

  getDaysCompleted() {
    return dayjs().diff(dayjs(this.goal.from), 'day');
  }
  getDaysTotal() {
    return dayjs(this.goal.to).diff(dayjs(this.goal.from), 'day');
  }

  get totalValue() {
    return this.goal.value || 0;
  }

  get policedValue() {
    return (this.result?.policedValue || 0) + this.canceledValue;
  }

  get canceledValue() {
    return this.result?.canceledValue || 0;
  }

  get relativePolicedValue() {
    if (this.result?.policedRelativeValue) {
      return this.result.policedRelativeValue;
    }
    return 0;
  }

  get submittedValue() {
    return this.result?.submittedValue || 0;
  }
  get relativeSubmittedValue() {
    if (this.result?.submittedRelativeValue) {
      return this.result.submittedRelativeValue;
    }
    return 0;
  }

  get openValue() {
    return this.result?.openValue || 0;
  }

  get relativeOpenValue() {
    if (this.result?.openRelativeValue) {
      return this.result.openRelativeValue;
    }
    return 0;
  }
  get currentValue() {
    return this.result?.currentValue;
  }

  get timeValueTooltip() {
    return `Nach ${this.getDaysCompleted()} von ${this.getDaysTotal()} Tagen`;
  }
  get timeValueTooltipReached() {
    const result = this.type === 'policed' ? 'Policiert' : 'Ergebnis';
    return `Zeitziel: ${result} + Eingereicht`;
  }
  get valueTooltipReached() {
    const result = this.type === 'policed' ? 'Policiert' : 'Ergebnis';
    return `Erreichtes Ziel: ${result} + Eingereicht`;
  }

  get agencyRowClass() {
    return this.goal.user ? '' : 'agency-row';
  }

  get resultValue() {
    return (this.type === 'policed' ? this.policedValue : this.result?.currentValue?.value) || 0;
  }
  get timeValue() {
    if (this.goal.value) {
      return Math.round(Util.relativeValue(this.goal.value, this.goal.from, this.goal.to));
    }
    return 0;
  }
  get resultAndSubmitted() {
    return this.submittedValue + this.resultValue;
  }

  get goalReachedInPercent() {
    return (this.resultAndSubmitted / this.goal.value!) * 100;
  }

  get goalTimeReachedInPercent() {
    return (this.resultAndSubmitted / this.timeValue) * 100;
  }
  get goalTimeReachedSuccess() {
    return this.goalTimeReachedInPercent > 75;
  }
  get goalReachedSuccess() {
    return this.goalReachedInPercent > 75;
  }
  round(n: number) {
    return Math.round(n * 10) / 10;
  }

  currentValueDateStr() {
    if (this.result?.currentValue) {
      return Util.formatDate(this.result?.currentValue.createdAt);
    }
    return '';
  }
}
